import { render, staticRenderFns } from "./Contact.vue?vue&type=template&id=405ea28a&scoped=true&"
import script from "./Contact.vue?vue&type=script&lang=js&"
export * from "./Contact.vue?vue&type=script&lang=js&"
import style0 from "./Contact.vue?vue&type=style&index=0&id=405ea28a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/.registry.npmjs.org/vue-loader/15.9.7_css-loader@3.6.0+webpack@4.46.0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "405ea28a",
  null
  
)

export default component.exports